module.exports = __webpack_public_path__ + "img/fall-2@2x.f01bcc8c.png";